import { BoardFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const BoardPersistenceProvider = createStaticContextProvider(
  BoardFirestorePersistenceContext,
  lazyValue(() =>
    import("./board-persistence").then((module) => module.boardPersistence),
  ),
);
